module.exports = "https://static.wmbcdn.com/uniweb/images/4b8dbaac9ae6d35c2b36fbfcbd975feb.svg";